import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";
import { subscriptionsCrudStateConfig } from "seneca-common/features/subscriptions/state/consts";

export const {
  fetchAllActionFactory: fetchAllSubscriptionsActionFactory,
  fetchActionFactory: fetchSubscriptionActionFactory,
  updateActionFactory: updateSubscriptionActionFactory,
  createActionFactory: createSubscriptionActionFactory
} = makeCrudStateActionFactories(subscriptionsCrudStateConfig);
